// import { useAppSelector } from "../store/store";
// import { Navigate } from "react-router-dom";

// export default function AdminProtectedRoute({ children }: any) {
//   const token = useAppSelector((state) => state.admin.access_token);

//   if (!token) return <Navigate to="/admin/login" replace />;

//   return children;
// }



import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import { logout } from "../store/reducers/slices/adminSlice";
import { jwtDecode } from "jwt-decode";

export default function AdminProtectedRoute({
  children,
}: any) {

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const token = useAppSelector(
    (state) => state.admin.access_token
  );


  useEffect(() => {

  if (!token) return;

  try {

    const decoded: any =
      jwtDecode(token);

    const currentTime =
      Date.now() / 1000;

    if (decoded.exp < currentTime) {

      dispatch(logout());

      localStorage.clear();

      navigate("/login");

    }

  } catch {

    dispatch(logout());

    localStorage.clear();

    navigate("/login");
  }

  }, [dispatch, navigate, token]);


  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
